<script setup>
import { useResultsStore } from "../../stores/results";
import { useFilterStore } from "../../stores/filter";
import Icon from "../Common/Icon.vue";
import { useCollectionStore } from "../../stores/collection";
const emit = defineEmits(["open-filter", "toggle-order", "refresh", "toggle-unseen"]);

// Stores
const filterStore = useFilterStore();
const resultsStore = useResultsStore();
const collectionStore = useCollectionStore();
</script>

<template>
  <div class="container content-top-padding mb-8 md:mb-16 lg:mb-20 text-16 lg:text-20">
    <h1 v-t="'home.headline'" class="font-bold text-31 sm:text-39 md:text-49 xxl:text-76 mb-10 md:mb-16 xxl:mb-20 lg:max-w-[90%]"></h1>

    <div class="md:flex space-y-4 md:space-y-0 items-center flex-wrap gap-y-6 gap-x-10 lg:gap-x-20">
      <button
        type="button"
        @click="emit('open-filter')"
        :class="filterStore.isAnyFilterActive ? 'text-primary' : ''"
        class="flex items-center gap-x-4 text-dark hover:text-primary transition-colors"
      >
        <Icon name="filter" class="size-5 shrink-0" />
        <div>
          <span v-t="'button.filter'"></span>
          <span v-if="collectionStore.activeCollection" v-text="` (${collectionStore.activeCollection.name})`"></span>
        </div>
      </button>

      <button
        type="button"
        @click="emit('toggle-order')"
        :disabled="resultsStore.isLoading"
        class="flex items-center gap-x-4 disabled:opacity-70 disabled:pointer-events-none hover:text-primary transition"
      >
        <Icon :name="`order-${filterStore.order}`" class="size-5 shrink-0" />
        <span v-t="`button.order.date.${filterStore.order}`"></span>
      </button>

      <button
        type="button"
        @click="emit('refresh')"
        :disabled="resultsStore.isLoading"
        class="flex items-center gap-x-4 disabled:opacity-70 disabled:pointer-events-none hover:text-primary transition"
      >
        <Icon name="refresh" class="size-5 shrink-0" />
        <span v-t="'button.refresh'"></span>
      </button>

      <label
        for="filter-unseen"
        :class="resultsStore.isLoading ? 'opacity-70 pointer-events-none' : ''"
        class="flex gap-x-4 items-center cursor-pointer hover:text-primary transition"
      >
        <input
          type="checkbox"
          name="filter-unseen"
          id="filter-unseen"
          class="accent-primary shrink-0 size-5 cursor-pointer"
          @change="emit('toggle-unseen')"
        />
        <p v-t="'filter-unseen'"></p>
      </label>
    </div>
  </div>
</template>
